module.exports = __webpack_public_path__ + "img/791.94c0d5cb.jpg";